import Component from '../lib/Component'

import { gsap } from 'gsap'

export default class PortfolioSlider extends Component {
	static selector = '[data-portfolio-slider]'

	initialize() {
		const carousel = this.$$('.js-portfolio-slider')

		if (carousel.length > 0) {
			carousel.forEach((element) => {
				const elem = element.querySelector('.swiper')
				const loop = elem.dataset.loop
				const prevButton = element.querySelectorAll('.js-nav-prev')
				const nextButton = element.querySelectorAll('.js-nav-next')
				const progressBar = element.querySelector(
					'.swiper-progress-bar',
				)

				this.swiper = new Swiper(elem, {
					touchStartPreventDefault: false,
					autoHeight: true,
					spaceBetween: 1,
					slidesPerView: 1,
					navigation: {
						nextEl: '.js-nav-next',
						prevEl: '.js-nav-prev',
					},
					pagination: {
						el: '.swiper-pagination',
						type: 'custom',
						renderCustom: function (e, t, s) {
							return (
								('0' + t).slice(-2) + '/' + ('0' + s).slice(-2)
							)
						},
					},
					scrollbar: {
						el: '.swiper-progress-bar',
						hide: false,
					},
				})
				this.timelines = []

				this.animateSlides()
			})
		}
	}

	animateSlides() {
		const slides = this.swiper.slides
		const elements = this.$$(
			'.c-portfolio-item__title, .c-button, .c-portfolio-item__category',
		)
		// gsap.set(elements, { opacity: 0 })

		for (let i = 0; i < slides.length; i++) {
			const timeline = gsap.timeline({ paused: true })
			const detailsEl = slides[i].querySelectorAll(
				'.c-portfolio-item__left, .c-portfolio-item__right',
			)
			const skewElements = slides[i].querySelectorAll(
				'.c-portfolio-item__title, .c-button',
			)
			const fadeElements = slides[i].querySelectorAll(
				'.c-portfolio-item__category, .swiper-pagination, .c-portfolio-nav',
			)
			const galleryElements = slides[i].querySelectorAll(
				'.c-portfolio-item__gallery-item',
			)

			gsap.set(detailsEl, { autoAlpha: 1 })

			timeline.from(
				skewElements,
				{
					opacity: 0,
					y: 50,
					skewY: '2.5deg',
					duration: 0.3,
					stagger: 0.3,
					ease: 'sine.out',
					willChange: 'transform',
				},
				'start+=0.5',
			)

			timeline.from(
				galleryElements,
				{
					opacity: 0,
					y: 20,
					skewY: '8deg',
					willChange: 'transform',
					transformOrigin: 'bottom center',
					duration: 0.4,
					stagger: 0.2,
					ease: 'sine.out',
				},
				'start+=0.4',
			)

			timeline.from(
				fadeElements,
				{
					opacity: 0,
					skewY: '3deg',
					duration: 0.3,
					stagger: 0.2,
					ease: 'sine.out',
				},
				'start+=0.8',
			)

			this.timelines.push(timeline)
		}

		this.swiper.on('slideChange', () => {
			this.timelines.forEach((timeline) => timeline.pause())
			this.timelines[this.swiper.activeIndex].play()
		})

		// Play the timeline for the initial slide
		this.timelines[this.swiper.activeIndex].play()

		// Update the timeline when the slide is changed by Swiper
		this.swiper.on('slideChange', () => {
			this.timelines.forEach((timeline, index) => {
				if (index === this.swiper.activeIndex) {
					timeline.play()
				} else {
					timeline.reverse()
				}
			})
		})
	}
}
